import defineMessages from "../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    lookUp: {
        id: "embed.lookUp",
    },
});

export default messages;
